import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './AppIcon';

const LanguageDropdown = () => {
  const { t, i18n } = useTranslation();
  
  // Generate language options based on configured languages
  const languages = [
    { code: 'en', labelKey: 'languageNameEn', icon: '🇬🇧' },
    { code: 'zh', labelKey: 'languageNameZh', icon: '🇨🇳' },
    { code: 'id', labelKey: 'languageNameId', icon: '🇮🇩' },
    { code: 'fil', labelKey: 'languageNameFil', icon: '🇵🇭' }
  ];
  
  const currentLanguage = languages?.find(lang => lang?.code === i18n?.language) || languages?.[0];
  
  return (
    <div className="relative group">
      <button className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-emerald-600 dark:hover:bg-slate-700 transition-colors">
        <Icon name="Languages" size={20} />
        <span className="hidden lg:inline text-sm font-medium">{currentLanguage?.icon}</span>
      </button>
      {/* Dropdown Menu */}
      <div className="absolute right-0 mt-2 w-56 bg-white dark:bg-slate-800 rounded-lg shadow-xl border border-gray-200 dark:border-slate-700 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        <div className="p-2">
          <div className="px-3 py-2 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">
            {t('language')}
          </div>
          {languages?.map((lang) => (
            <button
              key={lang?.code}
              onClick={() => i18n?.changeLanguage(lang?.code)}
              className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left transition-colors ${
                i18n?.language === lang?.code
                  ? 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400' :'hover:bg-gray-100 dark:hover:bg-slate-700 text-gray-700 dark:text-gray-300'
              }`}
            >
              <span className="text-xl">{lang?.icon}</span>
              <span className="flex-1 text-sm font-medium">{t(lang?.labelKey)}</span>
              {i18n?.language === lang?.code && (
                <Icon name="Check" size={16} className="text-emerald-600 dark:text-emerald-400" />
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageDropdown;